import { Storage } from '@trello/storage';

const StorageKey = 'error_history';

interface Entry {
  timestamp: string;
  stack: string | undefined;
  name: string | undefined;
  msg: string | undefined;
  url: string | undefined;
}

export const recent = (): Entry[] => {
  const entries = Storage.get(StorageKey);

  if (entries instanceof Array) {
    return entries;
  }

  return [];
};

export const add = (entry: Entry) => {
  const entries = recent();
  if (entries) {
    entries.unshift(entry);
    Storage.set(StorageKey, entries.splice(0, 5));
  }
};
